var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNccaEDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 11.635,
    viewBox: "0 0 15.998 11.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173477"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21280",
    d: "M.615 0h14.768A.678.678 0 0 1 16 .727v10.181a.678.678 0 0 1-.615.727H.615A.678.678 0 0 1 0 10.908V.727A.678.678 0 0 1 .615 0z",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21283",
    d: "M.606 0h13.332a.675.675 0 0 1 .606.727v5.818H0V.727A.675.675 0 0 1 .606 0z",
    transform: "translate(.729 .727)",
    style: {
      opacity: 0.999,
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21282",
    d: "M0 0h8.363v2.909H.727A.727.727 0 0 1 0 2.182z",
    transform: "translate(.729 7.999)",
    style: {
      fill: "#f4b545",
      opacity: 0.999
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21281",
    d: "M0 0h5.454v2.182c0 .4-.212.727-.474.727H0z",
    transform: "translate(9.818 7.999)",
    style: {
      opacity: 0.999,
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21279",
    d: "M3.454 2a1.454 1.454 0 1 0 1.455 1.454A1.454 1.454 0 0 0 3.454 2zm.774 1.547-1.247.623a.1.1 0 0 1-.15-.093V2.831a.1.1 0 0 1 .15-.093l1.247.623a.1.1 0 0 1 0 .186z",
    transform: "translate(4.543 .545)",
    style: {
      fill: "#3b82f4"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNccaEDetail);
export default __webpack_public_path__ + "static/media/NCCA-e-Detail.684a99b394d43d7d7617c1be94f9ce55.svg";
export { ForwardRef as ReactComponent };